import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container px-4 mx-auto text-left pt-10 lg:pb-10 flex justify-center items-start" }
const _hoisted_2 = { class: "w-full lg:w-2/3 xl:w-1/2 mt-8" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Zaloguj się ")
const _hoisted_4 = { class: "my-8 grid sm:grid-cols-2 gap-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Zaloguj się ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Nie pamiętasz hasła? ")
const _hoisted_7 = { class: "text-center text-sm" }

import { ref } from 'vue'
import { UiButton, UiHeading, UiInput, UiTitle } from '@/components/common/ui'
import { useAuth } from '@/composables/useAuth'
import { useRouter } from 'vue-router'
import { useNotifications } from '@/composables/useNotifications'
import { ELoginResultType } from '@/types/enums/auth'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { login, loading } = useAuth()
const router = useRouter()
const { pushFail } = useNotifications()

const email = ref<string>(
    process.env.VUE_APP_MODE !== 'development' && process.env.VUE_APP_EMAIL
        ? ''
        : process.env.VUE_APP_EMAIL,
)
const password = ref<string>(
    process.env.VUE_APP_MODE !== 'development' && process.env.VUE_APP_PASS
        ? ''
        : process.env.VUE_APP_PASS,
)
const version = ref<string>(`v${process.env.PACKAGE_VERSION}`)
const handleLogin = async () => {
    try {
        const { type, passwordResetToken } = await login(email.value, password.value)
        switch (type) {
            case ELoginResultType.SUCCESS:
                router.push({ name: 'advices' })
                break
            case ELoginResultType.PASSWORD_EXPIRED:
                router.push({ path: `/reset-password-token/${passwordResetToken}` })
                break
        }
    } catch (error) {
        pushFail('Wprowadzono błędny login lub hasło')
    }
}
const handleResetPassword = () => {
    router.push({ name: 'reset-password' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(UiHeading), { title: "Logowanie" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(UiTitle), { class: "mb-8" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_unref(UiInput), {
          modelValue: email.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
          placeholder: "Adres e-mail"
        }, null, 8, ["modelValue"]),
        _createVNode(_unref(UiInput), {
          modelValue: password.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          type: "password",
          placeholder: "Hasło"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(UiButton), {
            loading: _unref(loading),
            primary: "",
            onClick: handleLogin
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_unref(UiButton), { onClick: handleResetPassword }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(version.value), 1)
      ])
    ])
  ], 64))
}
}

})